import { inject, injectable } from 'inversify'
import symbols from '../../symbols'
import {
  AddVcInvestmentInvitationUseCaseInput,
  AddVcInvestmentInvitationUseCaseOutput,
  IAddVcInvestmentInvitationUseCase,
  IAppErrorFactory,
  IInvitationsService,
} from '../../types'

@injectable()
export default class AddVcInvestmentInvitationInteractor implements IAddVcInvestmentInvitationUseCase {
  @inject(symbols.IInvitationsService) private invitationsService: IInvitationsService

  @inject(symbols.IAppErrorFactory) private errorFactory: IAppErrorFactory

  async handle(input: AddVcInvestmentInvitationUseCaseInput): Promise<AddVcInvestmentInvitationUseCaseOutput> {
    const output = this.getDefaultOutputData()
    try {
      output.invitationLink = await this.invitationsService.addVcInvestmentInvitation(input)
    } catch (e) {
      output.error = this.errorFactory.create({
        originalInstance: e as Error,
      })
    }

    return output
  }

  private getDefaultOutputData(): AddVcInvestmentInvitationUseCaseOutput {
    return {
      invitationLink: null,
      error: null,
    }
  }
}
